import { getStorage, connectStorageEmulator } from 'firebase/storage';
import firebase from './firebase';

const storage = getStorage(firebase);

const hostname = window.location.hostname;
if (hostname === 'localhost' || hostname === '127.0.0.1') {
  connectStorageEmulator(storage, hostname, 9199);
}

export default storage;
